import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'

import Barcode from '../components/barcode'

class TopFive extends React.Component {
  render() {
    return(<div className="column">
    <p>The top 5 UK <strong>{this.props.flow}</strong> <span className="data-backed"> {this.props.name} </span>
      in {this.props.year} were:</p>
    <table className="top5">
      <thead>
<tr><th>% of all UK {this.props.flow} {this.props.name}</th><th>classification</th></tr>
      </thead>
      {this.props.data.map(([item, value],index) => (
        <tr key={index}>
          <td style={{verticalAlign: "top"}}><span className="data-backed big">{value}%</span></td>
          <td className="left"><span className="data-backed">{item.replace(/^[\d]*/i, '')}</span></td>
        </tr>
      ))}
    </table>
  </div>)
  }
}


class ProfileTemplate extends React.Component {
  render() {
    const profile = this.props.data.profileJson
    return (<main>
      <Helmet title={profile.name}/>
      <header>
        <div className="logo">Department for International Trade</div>
        <div>Analysis – Statistics Brief</div>
      </header>
      <section>
        <h1>
          Trade and investment between the United Kingdom and
          <strong>{profile.name}</strong>
          <small>{'{data reported by the UK}'}</small>
        </h1>
      </section>
      <section>
        <h2>GLOBAL STANDING</h2>
        <p className="explain">2016 (latest available rankings)</p>
        <table>
          <thead>
            <tr>
              <th>Trading partner</th>
              <th>Export market</th>
              <th>Import market</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <span className="data-backed big">{profile.rankTradingPartner}</span>
                <span className="data-backed">{profile.pcTradingPartner}%</span> of total UK trade
              </td>
              <td><span className="data-backed big">{profile.rankExportMarket}</span>
                <span className="data-backed">{profile.pcExportMarket}%</span> of all UK exports</td>
              <td><span className="data-backed big">{profile.rankImportMarket}</span><span className="data-backed">{profile.pcImportMarket}%</span> of all UK imports</td>
            </tr>
          </tbody>
        </table>
      </section>
      <section>
        <h2>TRADE IN GOODS</h2>
        <p className="explain">
          The following figures are from the ONS and are on a Balance of Payments (‘change of ownership’) basis
        </p>
        <p className="big">
          The UK reported a trade in goods
          <span className={profile.totalSurplusOrDeficit}>
            <span className="data-backed"> {profile.totalSurplusOrDeficit} </span>
           with {profile.name} of <span className="data-backed"> £{profile.totalSurplusOrDeficitValue}</span></span>, compared to a trade in goods
          <span className={profile.totalSurplusOrDeficitPrevious}><span className="data-backed"> {profile.totalSurplusOrDeficitPrevious} </span>
          of <span className="data-backed"> £{profile.totalSurplusOrDeficitPreviousValue} </span></span>
          in 2016.
        </p>
<table>
  <thead>
    <tr>
      <th>Total trade in goods <small>between the UK and
      <span className="data-backed"> {profile.name} </span></small></th>

      <th>UK exports of goods<small>to
      <span className="data-backed"> {profile.name} </span></small></th>
        <th>UK imports of goods<small>from
        <span className="data-backed"> {profile.name} </span></small></th>
    </tr>
  </thead>
  <tbody>
<tr>
  <td><span className="data-backed big">£{profile.totalTrade}</span>
  (<span className="data-backed"> {profile.totalTradeChange} </span>
  from 2016 )
</td>
<td><span className="data-backed big">£{profile.totalExports}</span>
(<span className="data-backed"> {profile.totalExportsChange} </span>
from 2016 )
</td>
<td><span className="data-backed big">£{profile.totalImports}</span>
(<span className="data-backed"> {profile.totalImportsChange} </span>
from 2016 )
</td>
</tr>
  </tbody>
</table>

<Barcode data={this.props.data.site.siteMetadata.visualisation} selected={profile.name}/>


        <p className="explain">The following figures, on trade in goods only, are from HMRC. They are on a different (i.e. ‘physical movement’) basis than the ONS (‘Balance of Payments’) data which are based on the ‘change of ownership’ criterion. They are not directly comparable with the figures above.</p>
<div className="columns">
        <TopFive
          flow="goods exported to"
          name={profile.name}
          year="2017"
          data={profile.topGoodsExported}/>
          <TopFive
            flow="goods imported from"
            name={profile.name}
            year="2017"
            data={profile.topGoodsImported}/>
        </div>
      </section>
      <footer>
        {this.props.data.allProfileJson.edges.map(({ node }) => (
          <div key={node.fields.slug}>
            <Link to={node.fields.slug}>{node.name}</Link>
          </div>
        ))}
      </footer>
    </main>)
  }
}

export default ProfileTemplate

export const pageQuery = graphql `
  query CountryProfile($slug: String!) {
    site {
      siteMetadata {
        title
        visualisation {
          maxVal
          country {
           name
           total
           imports
           exports
         }
       }
      }
    }
    allProfileJson {
      totalCount
      edges {
        node {
          name
          fields {
            slug
          }
        }
      }
    }
    profileJson(fields: { slug: { eq: $slug } }) {
      name
      nextRelease
      updated
      totalTrade
      totalTradeChange
      totalExports
      totalExportsChange
      totalImports
      totalImportsChange
      totalSurplusOrDeficit
      totalSurplusOrDeficitValue
      totalSurplusOrDeficitPrevious
      totalSurplusOrDeficitPreviousValue
      importsAsPercentageOfTotal
      exportGoodsValue
      exportGoodsPC
      exportServicesValue
      exportServicesPC
      importGoodsValue
      importGoodsPC
      importServicesValue
      importServicesPC
      goodsSurplusOrDeficit
      goodsSurplusOrDeficitValue
      servicesSurplusOrDeficit
      servicesSurplusOrDeficitValue
      rankTradingPartner
      pcTradingPartner
      rankImportMarket
      pcImportMarket
      rankExportMarket
      pcExportMarket
      topServicesExported
      topServicesImported
      topGoodsExported
      topGoodsImported
      businessesExportingCount
      businessesExportingWorth
      businessesImportingCount
      businessesImportingWorth
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/country-profile.js